import React from 'react';
import {
  Box,
  Typography,
  useTheme,
  Divider,
  Card,
} from '@ublend-npm/aulaui-core';
import { useDispatch, useSelector } from 'react-redux';
import { toggleWidgetPreference } from '../../../../../actions/home/widgetPreferences';
import { WidgetPreference } from '@core/types/state';
import Switch from '@app/components/presentational/common/Switch';
import widgetsLibrary from '../../widgetsLibrary';

const ManageWidget = () => {
  const dispatch = useDispatch();
  const { palette } = useTheme();

  const widgetPreferences: WidgetPreference[] | null = useSelector(
    (state: any) => state.home?.widgetPreferences
  );
  const [loadingKey, setLoadingKey] = React.useState<string | null>(null);

  const handleToggle = async (widgetId: string, currentIsHidden: boolean) => {
    setLoadingKey(widgetId);
    await (dispatch as any)(toggleWidgetPreference(widgetId, !currentIsHidden));
    setLoadingKey(null);
  };

  const widgetEntries = widgetsLibrary
    .filter((w) => w.id !== 'home-manage-widget')
    .reduce((acc, widget) => {
      acc[widget.id] = widget;
      return acc;
    }, {} as Record<string, any>);

  return (
    <Card
      sx={{
        borderRadius: '0.75rem',
        padding: '1.5rem',
        boxShadow: 'none',
        border: `1px solid ${palette.divider}`,
        bgcolor: palette.background.paper,
        backgroundImage: 'none',
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight="medium"
        color="primary"
        mb={4}
      >
        Manage widgets
      </Typography>

      {Object.entries(widgetEntries).map(
        ([widgetId, widgetInfo]: any, index) => {
          const widgetPref = widgetPreferences?.find(
            (w) => w.widgetId === widgetId
          );
          const isLast = index === Object.keys(widgetEntries).length - 1;

          return (
            <>
              <Box
                key={widgetId}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" alignItems="center" gap="16px">
                  <Box
                    width="52px"
                    height="52px"
                    borderRadius="50%"
                    bgcolor={
                      palette.mode === 'dark' ? '#513093' : palette.primary.main
                    }
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mb={0}
                    color="white"
                    position="relative"
                  >
                    {widgetInfo.icon}
                    <Box
                      position="absolute"
                      bottom="-4px"
                      right="-4px"
                      bgcolor={palette.warning.main}
                      color="white"
                      fontSize="11px"
                      fontWeight={700}
                      width="20px"
                      height="20px"
                      borderRadius="50%"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      1
                    </Box>
                  </Box>
                  <Box>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                      fontWeight="medium"
                    >
                      {widgetInfo.title}
                    </Typography>
                    <Typography color="textSecondary" variant="body2">
                      Toggle to{' '}
                      {widgetPref
                        ? widgetPref.isHidden
                          ? 'unhide'
                          : 'hide'
                        : 'hide'}
                    </Typography>
                  </Box>
                </Box>
                <Switch
                  checked={widgetPref ? !widgetPref.isHidden : true}
                  onChange={() =>
                    handleToggle(
                      widgetId,
                      widgetPref ? widgetPref.isHidden : false
                    )
                  }
                  disabled={loadingKey === widgetId}
                />
              </Box>
              {!isLast && (
                <Divider
                  sx={{
                    marginBlock: 3,
                  }}
                />
              )}
            </>
          );
        }
      )}
    </Card>
  );
};

export default ManageWidget;
